import React from 'react';

export default function EmailSyncStatus({ syncStatus, newEmails, isSyncing, error }) {
  if (!syncStatus && !isSyncing) {
    return null;
  }

  return (
    <div
      className={`mb-4 p-4 rounded-lg border-l-4 ${
        error
          ? 'bg-error-container border-error text-on-error-container'
          : 'bg-primary-fixed border-primary text-on-primary-fixed'
      }`}
    >
      <div className="flex items-center gap-2">
        {isSyncing && (
          <div className="animate-spin">
            <span className="text-lg">⟳</span>
          </div>
        )}
        {!isSyncing && !error && <span className="text-lg">✓</span>}
        {error && <span className="text-lg">⚠</span>}
        <p className="font-medium text-sm">
          {isSyncing ? 'Syncing New Track emails...' : syncStatus}
        </p>
      </div>

      {newEmails.length > 0 && !isSyncing && (
        <ul className="mt-3 space-y-1 ml-6">
          {newEmails.slice(0, 5).map((subject, idx) => (
            <li key={idx} className="text-xs opacity-90">
              • {subject}
            </li>
          ))}
          {newEmails.length > 5 && (
            <li className="text-xs opacity-75 italic">+ {newEmails.length - 5} more...</li>
          )}
        </ul>
      )}
    </div>
  );
}
